import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, Collapse, Table, Spin, Modal, Form, Input, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import useCoursesDetail from "PlatForms/OrgLMS/Hooks/AdminHooks/useCourseDetail";
const { Option } = Select;
const CourseDetail = () => {
  const { id } = useParams();
  const [contentType, setContentType] = useState(null);
  const [form] = Form.useForm();
  const {
    fileType,
    isModalOpen,
    uploading,
    allCourseTypes,
    filteredFileTypes,
    allTypes,
    columns,
    getTypeLabel,
    loading,
    getCourses,
    setIsModalOpen,
    setFileList,
    handleSubmit,
    setFileType,
    fileList,
  } = useCoursesDetail(id, contentType, form);
  const navigate = useNavigate();
 // Modal State
  const showModal = () => setIsModalOpen(true);
  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
  };
  return (
    <Card
      loading={loading}
      title="Course Detail"
      className="card-professional"
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      {/* Add Course Item Button */}
      <Button type="primary" style={{ marginBottom: "10px" }} onClick={showModal}>
        Add Course Item
      </Button>
      {/* Course Title & Description */}
      <p className="course-details">
        <strong>Course Title :</strong> {getCourses?.title}
      </p>
      {getCourses?.description && (
        <p className="course-details">
          <strong>Description :</strong> {getCourses.description}
        </p>
      )}
      <p className="course-details">
        <strong>Training Duration for this Course:</strong> {getCourses?.duration}
      </p>
      {/* Course Files Table */}
      <Collapse
        accordion
        items={allTypes.map((type, index) => {
          const typeData =
            getCourses?.courseFiles?.filter((file) => getTypeLabel(file.contentType) === type) ||
            [];
          return {
            key: index,
            label: <span className="panel-header">{type}</span>,
            children: loading ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <Spin size="large" />
                <h5>Please Wait...</h5>
              </div>
            ) : (
              <Table
                columns={columns}
                dataSource={typeData}
                pagination={false}
                rowKey="id"
                locale={{ emptyText: `No ${type} available.` }}
                scroll={{ x: "max-content" }}
              />
            ),
          };
        })}
      />
      {/* Add Course Item Modal */}
      <Modal
        title="Add Course Item"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          {/* Content Type Dropdown */}
          <Form.Item
            name="contentType"
            label="Content Type"
            rules={[{ required: true, message: "Please select content type" }]}
          >
            <Select
              placeholder="Select Content Type"
              onChange={(value) => {
                setContentType(value);
                form.setFieldsValue({ fileType: undefined });
              }}
            >
              {allCourseTypes.map((type) => (
                <Option key={type.value} value={type.value}>
                  {type.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {/* Title Input */}
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: "Please enter title" }]}
          >
            <Input placeholder="Enter Title" />
          </Form.Item>
          {/* File Type Dropdown */}
          <Form.Item
            name="fileType"
            label="File Type"
            rules={[{ required: true, message: "Please select file type" }]}
          >
            <Select placeholder="Select File Type" onChange={(value) => setFileType(value)}>
              {filteredFileTypes.map((type) => (
                <Option key={type.value} value={type.value}>
                  {type.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {/* File Upload */}
          <Form.Item
            name="file"
            label="Upload File"
            rules={[{ required: true, message: "Please upload a file" }]}
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) {
                return e;
              }
              return e && e.fileList;
            }}
          >
            <Upload
              beforeUpload={() => false}
              onChange={handleFileChange}
              fileList={fileList}
              maxCount={1}
              accept={
                fileType === 1
                  ? ".pdf"
                  : fileType === 2
                    ? ".csv,.xlsx,.xls"
                    : fileType === 3
                      ? ".ppt,.pptx,.odp,.key"
                      : fileType === 4
                        ? ".mp4,.mkv,.mov,.webm,.m4v"
                        : "*"
              }
            >
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item>
          {/* Submit Button */}
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={uploading} disabled={uploading}>
              {uploading ? "Uploading..." : "Submit"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};
export default CourseDetail;
